'use client'

import * as AccordionPrimitive from '@radix-ui/react-accordion'
import * as React from 'react'

import { MinusCircle } from '@/components/icons/MinusCircle'
import { PlusCircle } from '@/components/icons/PlusCircle'
import { cn } from '@/lib/styles'

const Accordion = AccordionPrimitive.Root

const AccordionItem = React.forwardRef<
	React.ElementRef<typeof AccordionPrimitive.Item>,
	React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
	<AccordionPrimitive.Item
		ref={ref}
		className={cn('border-b border-neutral-900', className)}
		{...props}
	/>
))
AccordionItem.displayName = 'AccordionItem'

const AccordionTrigger = React.forwardRef<
	React.ElementRef<typeof AccordionPrimitive.Trigger>,
	React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
	<AccordionPrimitive.Header className="flex">
		<AccordionPrimitive.Trigger
			ref={ref}
			className={cn(
				'text-left flex w-full flex-1 items-center py-6 lg:py-8 text-sm font-medium transition-colors data-[state=open]:text-textRich-linkDefault [&[data-state=open]>.chevron]:text-textRich-linkDefault [&[data-state=open]>.minus-icon]:block [&[data-state=open]>.minus-icon]:text-textRich-linkDefault [&[data-state=open]>.plus-icon]:hidden cursor-pointer [&[data-state=open]>svg]:-rotate-90',
				className,
				children ? 'justify-between' : 'justify-end',
			)}
			{...props}
		>
			{children}

			{!props.disabled && (
				<>
					<PlusCircle className={cn('plus-icon shrink-0 transition-transform duration-200')} />
					<MinusCircle
						className={cn(
							'minus-icon hidden shrink-0 !rotate-0  transition-transform duration-200',
						)}
					/>
				</>
			)}
		</AccordionPrimitive.Trigger>
	</AccordionPrimitive.Header>
))
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

const AccordionContent = React.forwardRef<
	React.ElementRef<typeof AccordionPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
	<AccordionPrimitive.Content
		ref={ref}
		className="overflow-hidden text-base data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
		{...props}
	>
		<div className={cn('pb-8 pt-0', className)}>{children}</div>
	</AccordionPrimitive.Content>
))
AccordionContent.displayName = AccordionPrimitive.Content.displayName

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
